import { z } from 'zod'
import { ExclusiveOfferLegacyType } from '~library/enums'

export const getExclusiveOfferLegacyTypeListResponseSchema = z.object({
  /** 分類 */
  type: z.array(z.enum(ExclusiveOfferLegacyType))
})

export interface GetExclusiveOfferLegacyTypeListResponse extends z.infer<
  typeof getExclusiveOfferLegacyTypeListResponseSchema
> {}
